import { render, staticRenderFns } from "./batchAcountDetail.vue?vue&type=template&id=a0fc9524&scoped=true&"
import script from "./batchAcountDetail.vue?vue&type=script&lang=js&"
export * from "./batchAcountDetail.vue?vue&type=script&lang=js&"
import style0 from "./batchAcountDetail.vue?vue&type=style&index=0&id=a0fc9524&lang=less&scoped=true&"
import style1 from "./batchAcountDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fc9524",
  null
  
)

export default component.exports